export default (function myAccountInit() {
  const myAccount = {
    passToggle() {
      $('.js--pass_toggle').on('click', function () {
        $('.js--my_account__new_pass').slideToggle(300);
      })
    }
  };
  $(document).ready(function () {
    myAccount.passToggle()
  })
})()
